export default __webpack_public_path__ + "static/media/PASA.8c8517fa.png";